module.exports = __webpack_public_path__ + "img/bjnum-poprank-border-2.ddd4485e.png";